<template>
  <layout>
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getOrganizationalStructure" />
    <div class="organizational-container">
      <div class="organizational__title">
        {{companyInfo.name}}
      </div>
    </div>
    <organizational-menu :list="organizationalList"/>
  </layout>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useGetData } from '@/hooks/useGetData'
import { getCompanyEmpList } from '@/api/cemp'
import { getDetail } from '@/api/modifyCompany'

export default {
  name: 'CompanyEmp', // 雇员
  props: ['companyId'],
  provide: {
    hideOperation: true
  },
  setup (props) {
    // 获取组织架构数据
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const organizationalList = ref([])
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getCompanyEmpList, (data) => {
      organizationalList.value = data
    }, { companyId: companyId.value })
    const getOrganizationalStructure = getDataLoading
    getOrganizationalStructure()

    const companyInfo = ref([])
    const getCompanyInfo = useGetData(getDetail, (data) => {
      companyInfo.value = data
    })
    getCompanyInfo(companyId.value)

    return {
      showLoading,
      isLoading,
      organizationalList,
      companyInfo,
      getOrganizationalStructure,
      getCompanyInfo
    }
  }
}
</script>

<style lang="scss" scoped>
/* 组织架构 */
.organizational-container {
  margin: 16px;
  position: relative;
  .organizational {
    display: flex;
    align-items: center;
    &__icon {
      color: #1989fa;
      font-size: 14px;
      font-weight: normal;
      width: 20px;
    }
    &__title {
      font-size: 16px;
      color: #333;
      font-weight: 600;
      flex: 1;
      /* background-color: #fff; */
      padding: 5px 0;
      line-height: 20px;
    }
    &__ellipsis  {
      /* background-color: #fff; */
      padding: 5px;
      font-size: 18px;
      line-height: 20px;
    }
  }
}
</style>
